import type { ProfileModuleLike } from './types';

export function getModuleId(module: ProfileModuleLike): string {
  return String(module.id ?? '');
}
